/* dc i18n dictionary layer (chrome + product-template custom_liquid). 2026-09-01 */
(function () {
  if (window.__xi18n) return; window.__xi18n = 1;
  var CUR = window.__xiL || document.documentElement.getAttribute('lang') || 'en';
  if (CUR === 'en' || CUR.indexOf('en-') === 0) return;
  var sc = document.querySelector('script[src*="dc-i18n"]');
  var base = sc ? sc.src.split('dc-i18n')[0] : '';
  if (!base) return;
  function apply(map) {
    if (!map) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue, tr = t.trim();
      if (!tr) continue;
      var hit = map[tr];
      if (hit) n.nodeValue = t.replace(tr, hit);
    }
    document.querySelectorAll('input[placeholder]').forEach(function (i) {
      var hit = map[i.placeholder.trim()];
      if (hit) i.placeholder = hit;
    });
  }
  function watch(map) {
    if (!window.MutationObserver) return;
    var t = null;
    var mo = new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; apply(map); }, 250);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
  function load(u) {
    fetch(u).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (map) { if (!map) return; apply(map); window.addEventListener('load', function () { apply(map); watch(map); }); })
      .catch(function () {});
  }
  function go() {
    load(base + 'dc-i18n-chrome-' + CUR + '.json');
    if (window.__xiTpl !== undefined && window.__xiTpl !== null) load(base + 'dc-i18n-tpl-' + (window.__xiTpl || 'default') + '-' + CUR + '.json');
  }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();

/* ---- href prefix layer v3 (2026-09-04, 全店统一轮子) ----
   作用:在本地化路径(/it/、/de-ch/ …)下,把写死的站内链接补上当前语言前缀,点击不丢语言。
   v3 相对 v2:① 绝对链接(https://本站域名/collections/x,带不带 www 都算)也补前缀 ② 永不重复加前缀(按 Shopify.routes.root 判重 + 任何 xx / xx-yy 开头都视为已带语言)
   ③ 页面加载后再补两次(App 晚渲染的菜单)④ 点击时兜底。root 只信 Shopify.routes.root,不猜。 */
(function () {
  if (window.__xHrefFix3) return; window.__xHrefFix3 = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (!ROOT || ROOT === '/') return;
  var P = ROOT.replace(/\/+$/, '');
  var HOST = location.host.toLowerCase().replace(/^www\./, '');
  var SKIP = /^\/(a|cdn|admin|apps|tools|localization|checkout|gift_cards|wpm@|\d+)(\/|$)/;
  function pref(h) {
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return h;
    var path = h.split(/[?#]/)[0];
    if (SKIP.test(path)) return h;
    if (h === P || h.indexOf(P + '/') === 0 || h.indexOf(P + '?') === 0 || h.indexOf(P + '#') === 0) return h;
    var seg = path.split('/')[1] || '';
    if (/^[a-z]{2}(-[a-z]{2})?$/i.test(seg)) return h;
    return P + h;
  }
  function fix(a) {
    var h = a.getAttribute('href'); if (!h) return;
    if (/^(#|mailto:|tel:|sms:|javascript:)/i.test(h)) return;
    var m = h.match(/^(?:https?:)?\/\/([^\/?#]+)(.*)$/i);
    if (m) {
      if (m[1].toLowerCase().replace(/^www\./, '') !== HOST) return;
      var rest = m[2] || '/'; if (rest.charAt(0) !== '/') rest = '/' + rest;
      var n = pref(rest); if (n !== rest) a.setAttribute('href', n);
      return;
    }
    if (h.charAt(0) !== '/') return;
    var n2 = pref(h); if (n2 !== h) a.setAttribute('href', n2);
  }
  function fixAll() { var as = document.querySelectorAll('a[href]'); for (var i = 0; i < as.length; i++) fix(as[i]); }
  if (document.readyState !== 'loading') fixAll(); else document.addEventListener('DOMContentLoaded', fixAll);
  window.addEventListener('load', function () { fixAll(); setTimeout(fixAll, 1500); setTimeout(fixAll, 4000); });
  document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('a[href]'); if (a) fix(a); }, true);
})();
